import React, { useEffect, useState } from 'react'
import { Input, Row, Col, Button, Modal, Form, message, Divider, Menu, Dropdown, Avatar } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import { auth, account } from 'api';
import Utils from 'utils';
import { setLoading } from 'redux/actions/Loader';
import { useDispatch, useSelector } from 'react-redux';
import {
  UserOutlined,
} from '@ant-design/icons';
import { faAddressCard, faInbox, faRulerTriangle, faScrewdriverWrench, faFileInvoiceDollar, faCreditCard, faGrid2Plus, faBullhorn, faShareNodes, faLifeRing, faArrowRightFromBracket, faCommentLines, faGear, faArrowsRotate, faMegaphone } from '@fortawesome/pro-light-svg-icons'
import FAIcon from 'components/util-components/FAIcon';

import { saveAccount } from 'redux/actions/Account';
import { saveUser, saveUserAccounts, saveUserProfile } from 'redux/actions/User';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { clearSession, trackEvent } from 'utils/analytics-utils';
const { SubMenu } = Menu;
const { TextArea } = Input;

const menuItem = [
  {
    key: 'settings',
    title: 'Account Settings',
    path: '/settings/defaults',
    icon: faGear
  },
  {
    key: 'add-ons',
    title: 'Add-Ons & Integrations',
    path: '/settings/add-ons',
    icon: faGrid2Plus
  },
  {
    key: 'account-billing',
    title: 'Billing and Plan',
    path: '/settings/billing',
    icon: faCreditCard
  },
  {
    key: 'product-updates',
    title: 'Product Updates',
    path: '/',
    icon: faArrowsRotate
  },
  {
    key: 'docs',
    title: 'Documentation',
    path: null,
    icon: faLifeRing
  },
  {
    key: 'feedback',
    title: 'Give Feedback?',
    path: null,
    icon: faMegaphone
  },
  {
    key: 'refer-a-friend',
    title: 'Refer a Friend',
    path: '/',
    icon: faShareNodes
  }
]

export const NavProfile = ({ flags }) => {

  const history = useHistory();
  const currentAccount = useSelector(s => s.account?.details);
  const currentUser = useSelector(s => s.user?.details);
  const dispatch = useDispatch();

  const [contactUsForm] = Form.useForm();
  const [contactUsModalVisible, setContactUsModalVisible] = useState(false);
  const [contactUsLoadingIndicator, setContactUsLoadingIndicator] = useState(false);
  const onContactUsModalClose = () => {
    contactUsForm.resetFields();
    setContactUsModalVisible(false)
  };

  const contactUs = () => {

    setContactUsLoadingIndicator(true);
    contactUsForm.validateFields().then(async function (values) {
      let params = {
        email: values.email,
        organization: values.organization,
        first_name: values.first_name,
        last_name: values.last_name,
        comment: values.comment,
      }

      await account.sendFeedback(params).then(async (response) => {
        onContactUsModalClose();
        message.success('Message Sent')
        setContactUsLoadingIndicator(false);
      })

    }).catch(error => {
      console.log(error)
      setContactUsLoadingIndicator(false);
    });
  }

  const logout = async () => {
    dispatch(setLoading({
      loading: true,
      cover: 'overlay'
    }))
    trackEvent('Signed Out');
    clearSession();
    const response = await auth.logout();
    Utils.removeSessionToken();
    dispatch(saveUser({}))
    dispatch(saveAccount({}))
    dispatch(saveUserProfile({}))
    dispatch(saveUserAccounts([]))
    history.push('/login');
    dispatch(setLoading({
      loading: false
    }))
  }

  const handleAction = (el) => {
    const links = ['account-billing', 'settings']
    if (links.includes(el.key)) {
      history.push(el.path);
    }

    if (el.key === 'docs') {
      window.open('https://support.pushpulse.com/hc/en-us', '_blank');
    }

    if (el.key === 'feedback') {

      contactUsForm.setFieldsValue({
        email: currentUser.email,
        organization: currentAccount.name,
        first_name: currentUser.first_name,
        last_name: currentUser.last_name,
        comment: '',
      })

      setContactUsModalVisible(true)

    }
  }

  const userName = `${currentUser?.first_name} ${currentUser?.last_name}`;
  const profileMenu = (
    <div className="nav-profile nav-dropdown" style={{ width: 290 }}>
      <div className="nav-profile-header">
        <div className="app-userpreferences">
          <Link to="/settings/user-profile/contact">
            {currentUser?.profile_image ?
              <Avatar size={48} src={currentUser?.profile_image} className="app-nav-avatar" />
              :
              <Avatar size={48} className="app-nav-avatar"><UserOutlined /></Avatar>
            }
            <div className="app-user-info">
              <div className="app-user-info-name">{userName}</div>
              <div className="app-user-info-email">{currentUser?.email}</div>
              <div className="app-user-info-preferences">Profile &amp; Preferences</div>
            </div>
          </Link>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu className="app-userpreferences-menu">
          {menuItem.map((el, i) => {

            //if (el.key === 'product-updates' && !flags.productUpdates) {
            if (el.key === 'product-updates') {
              return null;
            }
            //            if (el.key === 'refer-a-friend' && !flags.referAFriend) {
            if (el.key === 'refer-a-friend') {
              return null;
            } 

            return (
              <Menu.Item key={i} onClick={() => handleAction(el)}>
                {(el.path !== null) ?

                  <Link to={el.path}>
                    <FAIcon icon={el.icon} className='anticon' />
                    <span className="font-weight-normal">{el.title}</span>
                  </Link>
                  :
                  <>
                    <FAIcon icon={el.icon} className='anticon' />
                    <span className="font-weight-normal">{el.title}</span>
                  </>
                }
              </Menu.Item>
            );
          })}
          {/*
          <SubMenu title={<span>
            <img style={{ width: '17px' }} src={'https://logopond.com/logos/d5980f6bf1cc10fd6ff22363cc8a697a.png'} alt={'ys'} className={'anticon'} />
            <span className="font-weight-normal">PushPulse</span>
          </span>}>
            <Menu.Item>
              <span>
                <span className="font-weight-normal app-user-view-accounts">View all accounts</span>
              </span>
            </Menu.Item>
            <Divider style={{ margin: '8px 0' }} />
            <Menu.Item>Account Name 1</Menu.Item>
            <Menu.Item>Account Name 2</Menu.Item>
          </SubMenu>
          */}
          <Menu.Item key={menuItem.length + 1} onClick={logout}>
            <span>
              <FAIcon icon={faArrowRightFromBracket} className='anticon' />
              <span className="font-weight-normal" >Sign Out</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <>

      <Dropdown placement="bottomRight" overlay={profileMenu} trigger={['click']}>
        <Menu className="d-flex align-item-center" mode="horizontal" >
          <Menu.Item key="profile" className="app-header-top-nav-menu-item">
            {currentUser?.profile_image ?
              <Avatar src={currentUser?.profile_image} />
              :
              <Avatar ><UserOutlined /></Avatar>
            }
          </Menu.Item>
        </Menu>
      </Dropdown>

      <Modal
        autoFocus={true}
        mask={true}
        closable={true}
        maskClosable={true}
        centered={true}
        title={'Give Feedback?'}
        visible={contactUsModalVisible}
        onClose={onContactUsModalClose}
        onCancel={onContactUsModalClose}
        footer={
          <>
            <Button onClick={onContactUsModalClose} type="primary" ghost >Cancel</Button>
            <Button type="primary" onClick={contactUs} loading={contactUsLoadingIndicator}>
              Submit
            </Button>
          </>
        }
      >
        <Form
          form={contactUsForm}
          layout="vertical"
          name="form"
          requiredMark={false}
          initialValues={{ email: '', organization: '', first_name: '', last_name: '', comment: '' }}
        >

          <Row gutter={ROW_GUTTER}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="email"
                className="dark-input"
                rules={
                  [
                    {
                      required: true,
                      message: 'Email Address Required'
                    },
                    {
                      type: 'email',
                      message: 'Email Address Required'
                    }
                  ]
                }
              >
                <Input autoComplete="new-password" placeholder='Email Address' />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="organization"
                className="dark-input"
                rules={[{ required: true, message: 'Organization Name Required' }]}
              >
                <Input autoComplete="new-password" placeholder='Organization Name' />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={ROW_GUTTER}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="first_name"
                className="dark-input"
                rules={[{ required: true, message: 'First Name Required' }]}
              >
                <Input autoComplete="new-password" placeholder='First Name' />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="last_name"
                className="dark-input"
                rules={[{ required: true, message: 'Last Name Required' }]}
              >
                <Input autoComplete="new-password" placeholder='Last Name' />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={ROW_GUTTER}>
            <Col xs={24} sm={24} md={24}>

              <Form.Item
                name="comment"
                rules={[{ required: true, message: 'Comment Required' }]}
              >
                <TextArea rows={3} placeholder='How can we help?' />
              </Form.Item>
            </Col>
          </Row>

        </Form>
      </Modal>
    </>
  );
}

//export default NavProfile 
export default withLDConsumer()(NavProfile);
